import { render, staticRenderFns } from "./groupFitnessDashboardDownloads.vue?vue&type=template&id=93d33452&scoped=true"
import script from "./groupFitnessDashboardDownloads.vue?vue&type=script&lang=js"
export * from "./groupFitnessDashboardDownloads.vue?vue&type=script&lang=js"
import style0 from "./groupFitnessDashboardDownloads.vue?vue&type=style&index=0&id=93d33452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d33452",
  null
  
)

export default component.exports